module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-01"
  }, [_vm._v("[A wasp] was sucking jam on my plate and I cut him in half. He paid no attention, merely went on with his meal, while a tiny stream of jam trickled out of his severed esophagus. Only when he tried to fly away did he grasp the dreadful thing that had happened to him.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EORGE")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RWELL")]), _vm._v(", "), _c('i', [_vm._v("Collected Essays")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 72
// module chunks = 0